import { Component, Input, OnInit, HostListener } from '@angular/core';
import { getStorage } from 'src/app/utils/helper/storage';
import { CURRENT_USER } from 'src/app/utils/items/storage-names';

@Component({
  selector: 'app-patient-profile',
  templateUrl: './patient-profile.component.html',
  styleUrls: ['./patient-profile.component.scss']
})
export class PatientProfileComponent implements OnInit {
  
  @Input() patient: any;
  isLessThan900px: boolean = false;
  user: any;

  constructor() { 
    this.checkScreenSize();
  }

  ngOnInit(): void {
    this.user = getStorage(CURRENT_USER, true);
    window.scrollTo(0, 0);
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkScreenSize();
  }

  private checkScreenSize() {
    this.isLessThan900px = window.innerWidth < 900;
  }

  getContact(code) {
    return this.patient?.contacts?.find((contact) => contact?.type_code === code);
  }

  getAddress(name) {
    return this.patient?.addresses?.find((address) => address?.type_code === name)?.line1;
  }

  getAttribute(name) {
    return this.patient?.attributes?.find((attribute) => attribute?.type_text === name)?.value_text;
  }
}
